import * as dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { Form, InputPicker, SelectPicker, Toggle } from 'rsuite';
import Swal from 'sweetalert2';
import additionalInformationService from '../../../../../services/Internal/Credential/additionalInformation.service';
import { getStates, getSurveyingExamDiscipline } from '../../../../../services/Shared/codeTable.service';
import YesNoRadioOption from '../../../../Shared/RadioButton/YesNoRadioOption';
function AdditionalSurveyorInformationForm({ entityId, active, setUpdateBoldness, updateBoldness  }) {
    const [states, setStates] = useState([])
    const [examDiscipline, setExamDiscipline] = useState([])
    const [surveyModel, setSurveyModel] = useState({});
    const [isAct2, setIsAct2] = useState(false)
    const [isByEndorsement, setIsByEndorsement] = useState(false)

    useEffect(() => {
        getStates().then(setStates);
        getSurveyingExamDiscipline().then(setExamDiscipline);
    }, [])

    useEffect(() => {
        if (active) {
            additionalInformationService.getSurveyingAdditionalInfo(entityId).then((response) => {
                if (response.data) {
                    setSurveyModel({
                        ...response.data,
                        entityId: entityId,
                        lsiCertDate: response.data.lsiCertDate != null ? dayjs(response.data.lsiCertDate).format('YYYY-MM-DD') : null,
                        fsExamDate: response.data.fsExamDate != null ? dayjs(response.data.fsExamDate).format('YYYY-MM-DD') : null,
                        plsExamDate: response.data.plsExamDate != null ? dayjs(response.data.plsExamDate).format('YYYY-MM-DD') : null,
                        plsLicenseDate: response.data.plsLicenseDate != null ? dayjs(response.data.plsLicenseDate).format('YYYY-MM-DD') : null,
                        oralExamDate: response.data.oralExamDate != null ? dayjs(response.data.oralExamDate).format('YYYY-MM-DD') : null,
                        laLawsExamDate: response.data.laLawsExamDate != null ? dayjs(response.data.laLawsExamDate).format('YYYY-MM-DD') : null,
                    });
                    setIsAct2(response.data.isAct2);
                    setIsByEndorsement(response.data.isByEndorsement);
                }
            })
        }
    }, [active])

    const formSubmit = () => {
        var dataToTransmit = {
            ...surveyModel,
            lsiCertDate: surveyModel.lsiCertDate == '' ? null : surveyModel.lsiCertDate,
            fsExamDate: surveyModel.fsExamDate == '' ? null : surveyModel.fsExamDate,
            plsExamDate: surveyModel.plsExamDate == '' ? null : surveyModel.plsExamDate,
            plsLicenseDate: surveyModel.plsLicenseDate == '' ? null : surveyModel.plsLicenseDate,
            oralExamDate: surveyModel.oralExamDate == '' ? null : surveyModel.oralExamDate,
            laLawsExamDate: surveyModel.laLawsExamDate == '' ? null : surveyModel.laLawsExamDate,
            isAct2: isAct2,
            isByEndorsement: isByEndorsement
        }

        additionalInformationService.postSurveyingAdditionalInfo(dataToTransmit).then((response) => {
            if (response.data)
            {
                Swal.fire('Success!', 'You have successfully saved additional information for this LSI/PLS.', 'success');
                setUpdateBoldness(updateBoldness + 1);
            }
        })
    }
    const stateSearch = (userInput, label, dataItem) => {
        if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput)
            return true;
    }
    return (
        <Form fluid formValue={surveyModel} onChange={setSurveyModel} onSubmit={formSubmit}>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Comity State</b></Form.ControlLabel>
                        <Form.Control
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="comityState" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>LSI Cert. Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="lsiCertDate" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>LSI Cert #</b></Form.ControlLabel>
                        <Form.Control name="lsiCertNumber" />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>FS Exam Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="fsExamDate" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>FS Exam State</b></Form.ControlLabel>
                        <Form.Control
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="fsExamState" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS Exam Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="plsExamDate" />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS Exam State</b></Form.ControlLabel>
                        <Form.Control
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="plsExamState" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS Lic Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="plsLicenseDate" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS Lic State</b></Form.ControlLabel>
                        <Form.Control
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="plsLicenseState" />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">

                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS Lic #</b></Form.ControlLabel>
                        <Form.Control name="plsLicenseNumber" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Surveying Exam Discipline</b></Form.ControlLabel>
                        <Form.Control
                            data={examDiscipline}
                            accepter={InputPicker}
                            searchable={true}
                            block
                            name="plsExamDiscipline" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Oral Interview Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="oralExamDate" />
                    </Form.Group>
                </Col>

            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>LA Laws Exam Date</b></Form.ControlLabel>
                        <Form.Control type='date' name="laLawsExamDate" />
                    </Form.Group>
                </Col>
                <Col>
                </Col>
                <Col>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Model Law</b></Form.ControlLabel>
                        <YesNoRadioOption radioName="isModelLaw" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Act 2</b></Form.ControlLabel>
                        <Form.Control
                            accepter={Toggle}
                            size={'lg'}
                            checked={isAct2}
                            onChange={(val) => { setIsAct2(val); if (val) setIsByEndorsement(false); }} />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>PLS by Endorsement</b></Form.ControlLabel>
                        <Form.Control
                            accepter={Toggle}
                            size={'lg'}
                            checked={isByEndorsement}
                            onChange={(val) => { setIsByEndorsement(val); if (val) setIsAct2(false); }} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col className="text-end"><Button type="submit">Save</Button></Col>
            </Row>
        </Form>
    );
}
export default AdditionalSurveyorInformationForm;